import { useParams, useRouteContext } from '@tanstack/react-router';

export const useOrgName = (): string => {
  const params = useParams({ strict: false });
  const routeContext = useRouteContext({ strict: false });

  if ('org' in params && params.org) {
    return params.org;
  }

  return routeContext.organizationName ?? '';
};
